import React, { Component } from "react";
import { IoLogoGithub, IoIosPaperPlane } from "react-icons/io";
import { Flipped } from "react-flip-toolkit";

export class Card extends Component {
  render() {
    const { name, type, description, img, gitUrl, liveUrl } = this.props.data;

    return (
      <Flipped flipId={name}>
        <figure className={`card ${type}`}>
          <div className="card__side card__side--front">
            <img src={img} alt={name} className="img" />
          </div>
          <figcaption className="card__side card__side--back">
            <h2 className="h2 head">{name}</h2>
            <p className="desc">{description}</p>
            <div className="action">
              <a href={gitUrl} className="link github">
                <IoLogoGithub />
                <span>Github</span>
              </a>
              <a href={liveUrl} className="link live">
                <IoIosPaperPlane />
                <span>Live</span>
              </a>
            </div>
          </figcaption>
        </figure>
      </Flipped>
    );
  }
}

export default Card;
